import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../base/input.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule],
    selector: 'wd-text',
    templateUrl: 'text-view.component.html',
    styleUrls: ['../styles/view.component.css', '../styles/view-only.component.css'],
})
export class TextViewComponent extends InputComponent<string> {
	constructor() {
		super();
	}
}
